import { render } from "./AreaChartDatetimeXaxis.vue?vue&type=template&id=ce8c0610"
import script from "./AreaChartDatetimeXaxis.vue?vue&type=script&lang=js"
export * from "./AreaChartDatetimeXaxis.vue?vue&type=script&lang=js"

import "./AreaChartDatetimeXaxis.vue?vue&type=style&index=0&id=ce8c0610&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__